// /opt/isp_erp/frontend/src/pages/warehouse/RMAPage.jsx
import React, { useState, useEffect } from "react";
import {
  Box, Paper, Typography, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, TablePagination,
  Chip, Alert, CircularProgress,
} from "@mui/material";
import { warehouseAPI } from "../../api/warehouse.api";
import { mensajeError } from "../../utils/mensajesError";
import { cargarContextoBodega } from "../../utils/contextoBodega";
import RMACentral from "./RMA";

const NOMBRES_FALLA = {
  FISICO: "Daño físico", ELECTRONICO: "Falla electrónica", FIRMWARE: "Falla de firmware", CONEXION: "Falla de conexión", OTRO: "Otra falla",
};
const fmtFecha = (v) => (v ? new Date(v).toLocaleDateString("es-EC", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—");

function RMASucursal() {
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState(25);
  const [data, setData] = useState({ items: [], total: 0 });
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let vivo = true;
    setCargando(true);
    setError("");
    warehouseAPI.listarEquiposPaginado({ estado: "RMA_BAJA", page: page + 1, page_size: rows })
      .then((r) => { if (vivo) setData(r.data); })
      .catch((e) => { if (vivo) { setData({ items: [], total: 0 }); setError(mensajeError(e, "No se pudieron cargar los equipos en RMA")); } })
      .finally(() => { if (vivo) setCargando(false); });
    return () => { vivo = false; };
  }, [page, rows]);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>RMA de mi sucursal</Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Aquí ves los equipos que tu sucursal envió a la central para RMA. La central hace las actas, los reingresos y las bajas.
        Los equipos que están en revisión en tu sucursal se manejan en Bodega → Equipos (etiqueta "En revisión").
      </Alert>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: "#f5f5f5" }}>
              <TableCell>SN</TableCell>
              <TableCell>Modelo</TableCell>
              <TableCell>Tipo de falla</TableCell>
              <TableCell>Diagnóstico</TableCell>
              <TableCell>Fecha</TableCell>
              <TableCell>Estado</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {cargando && (<TableRow><TableCell colSpan={6} align="center" sx={{ py: 4 }}><CircularProgress size={28} /></TableCell></TableRow>)}
            {!cargando && data.items.length === 0 && (
              <TableRow><TableCell colSpan={6} align="center" sx={{ py: 4 }}>Tu sucursal no tiene equipos en RMA</TableCell></TableRow>
            )}
            {!cargando && data.items.map((e) => {
              const baja = (e.diagnostico_rma || "").startsWith("[BAJA DEFINITIVA]");
              return (
                <TableRow key={e.id} hover>
                  <TableCell><strong>{e.sn}</strong></TableCell>
                  <TableCell>{e.modelo}</TableCell>
                  <TableCell>{NOMBRES_FALLA[e.tipo_falla] || "No especificado"}</TableCell>
                  <TableCell sx={{ maxWidth: 320 }}>{e.diagnostico_rma || "—"}</TableCell>
                  <TableCell>{fmtFecha(e.fecha_rma)}</TableCell>
                  <TableCell><Chip size="small" color={baja ? "default" : "info"} label={baja ? "Baja definitiva" : "En RMA en la central"} /></TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <TablePagination component="div" count={data.total} page={page} onPageChange={(ev, p) => setPage(p)}
          rowsPerPage={rows} onRowsPerPageChange={(ev) => { setRows(parseInt(ev.target.value, 10)); setPage(0); }}
          rowsPerPageOptions={[10, 25, 50]} labelRowsPerPage="Filas" />
      </TableContainer>
    </Box>
  );
}

export default function RMAPage() {
  const [ctx, setCtx] = useState(undefined);

  useEffect(() => {
    let vivo = true;
    cargarContextoBodega().then((c) => { if (vivo) setCtx(c || { central: true, sucursales: [] }); });
    return () => { vivo = false; };
  }, []);

  if (ctx === undefined) return (<Box sx={{ p: 6, textAlign: "center" }}><CircularProgress /></Box>);
  if (ctx.central === false) return <RMASucursal />;
  return <RMACentral />;
}
